import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const CheckboxContainer = styled.label<{
  $color?: 'green' | 'red'
  disabled?: boolean
}>`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const StyledCheckbox = styled.span<{
  checked?: boolean
  $color?: 'green' | 'red'
  disabled?: boolean
  $width?: number | string
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $width }) =>
    $width ?
      typeof $width === 'number' ?
        `${$width}px`
      : $width
    : '16px'};
  height: ${({ $width }) =>
    $width ?
      typeof $width === 'number' ?
        `${$width}px`
      : $width
    : '16px'};
  background: ${({ checked, $color }) =>
    checked ?
      $color === 'red' ?
        Tokens.ColorUIDanger
      : Tokens.ColorUIPrimary
    : '#fff'};
  border: 2px solid ${({ $color }) => ($color === 'red' ? Tokens.ColorUIDanger : Tokens.ColorUIPrimary)};
  border-radius: 3px;
  transition: all 0.2s;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
`

export const CheckboxIcon = styled.span<{ $color?: 'green' | 'red' }>`
  font-size: 12px;
  font-weight: bold;
  color: ${({ $color }) => ($color === 'red' ? Tokens.ColorWhite : Tokens.ColorWhite)};
  line-height: 1;
  user-select: none;
`
